import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

const createConversationAPI = async content => {
  const urlData = endPoints.createConversation(content);
  return API.post(urlData.url, urlData.params);
};

const sendMessageAPI = async (content, replyTo, conversation_id) => {
  const urlData = endPoints.sendMessage(content, replyTo, conversation_id);
  return API.post(urlData.url, urlData.params);
};

const sendAttachmentAPI = async (
  conversation_id,
  attachment,
  replyTo = null
) => {
  const urlData = endPoints.sendAttachment(
    attachment,
    replyTo,
    conversation_id
  );
  return API.post(urlData.url, urlData.params);
};

const getMessagesAPI = async ({ before, after, conversation_id }) => {
  const urlData = endPoints.getConversation({ before, after, conversation_id });
  return API.get(urlData.url, { params: urlData.params });
};

const getConversationAPI = async conversationId => {
  const originalSearchParams = new URLSearchParams(window.location.search);
  if (conversationId) {
    originalSearchParams.set('conversation_id', conversationId);
  }
  const queryString = originalSearchParams.toString();
  const path = `/api/v1/widget/conversations${queryString ? `?${queryString}` : ''}`;
  return API.get(path);
};

const getConversationsListAPI = async () => {
  const urlData = endPoints.getConversationsList();
  return API.get(urlData.url);
};

const toggleTyping = async ({ typingStatus, conversation_id }) => {
  const separator = window.location.search ? '&' : '?';
  const conversationParam = conversation_id
    ? `${separator}conversation_id=${conversation_id}`
    : '';
  return API.post(
    `/api/v1/widget/conversations/toggle_typing${window.location.search}${conversationParam}`,
    { typing_status: typingStatus }
  );
};

const setUserLastSeenAt = async ({ lastSeen, conversation_id }) => {
  const separator = window.location.search ? '&' : '?';
  const conversationParam = conversation_id
    ? `${separator}conversation_id=${conversation_id}`
    : '';
  return API.post(
    `/api/v1/widget/conversations/update_last_seen${window.location.search}${conversationParam}`,
    { contact_last_seen_at: lastSeen }
  );
};

const sendEmailTranscript = async conversation_id => {
  const separator = window.location.search ? '&' : '?';
  const conversationParam = conversation_id
    ? `${separator}conversation_id=${conversation_id}`
    : '';
  return API.post(
    `/api/v1/widget/conversations/transcript${window.location.search}${conversationParam}`
  );
};

const toggleStatus = async conversation_id => {
  const separator = window.location.search ? '&' : '?';
  const conversationParam = conversation_id
    ? `${separator}conversation_id=${conversation_id}`
    : '';
  return API.get(
    `/api/v1/widget/conversations/toggle_status${window.location.search}${conversationParam}`
  );
};

const setCustomAttributes = async (customAttributes, conversation_id) => {
  const separator = window.location.search ? '&' : '?';
  const conversationParam = conversation_id
    ? `${separator}conversation_id=${conversation_id}`
    : '';
  return API.post(
    `/api/v1/widget/conversations/set_custom_attributes${window.location.search}${conversationParam}`,
    {
      custom_attributes: customAttributes,
    }
  );
};

const deleteCustomAttribute = async (customAttribute, conversation_id) => {
  const separator = window.location.search ? '&' : '?';
  const conversationParam = conversation_id
    ? `${separator}conversation_id=${conversation_id}`
    : '';
  return API.post(
    `/api/v1/widget/conversations/destroy_custom_attributes${window.location.search}${conversationParam}`,
    {
      custom_attribute: [customAttribute],
    }
  );
};

const botHandoffAPI = async conversation_id => {
  // The route is a member route, so conversation_id should be part of the path
  // and other params from window.location.search should still be appended.
  const path = `/api/v1/widget/conversations/${conversation_id}/bot_handoff${window.location.search}`;
  return API.post(path);
};

export {
  createConversationAPI,
  sendMessageAPI,
  getConversationAPI,
  getMessagesAPI,
  sendAttachmentAPI,
  toggleTyping,
  setUserLastSeenAt,
  sendEmailTranscript,
  toggleStatus,
  setCustomAttributes,
  deleteCustomAttribute,
  getConversationsListAPI,
  botHandoffAPI,
};
